export const OUTAGE_TASK_ROUTE = '/outages/:outageId/tasks/:taskId';
